import { A as AppText } from './index-6b88191c.esm.js';
import { A as AppInputLabel } from './index-5ae71f5a.esm.js';
import React__default from 'react';
import { View, StyleSheet, Platform } from 'react-native';
import { u as useTheme } from './useTheme-90e8e2c2.esm.js';
import { A as AppAssets } from './index-3256db5b.esm.js';

const AppRadio = _ref => {
  let {
    items,
    showTextInputLabel,
    wrapperContainer,
    label,
    isMandatory,
    enabled = true,
    propertyLabel,
    propertyValue,
    onSelectionChange = () => {},
    onSelectionDisabledPress = () => {},
    selectedOption,
    showCaption,
    caption,
    captionStyle,
    captionWrapperStyle,
    captionLabel,
    ...props
  } = _ref;
  const {
    currentTheme
  } = useTheme();
  const _style = styleGenerator(currentTheme, enabled);
  const _selectedOption = items === null || items === void 0 ? void 0 : items.find(i => i[propertyValue] == selectedOption);
  return /*#__PURE__*/React__default.createElement(View, {
    style: [_style.wrapperContainer, wrapperContainer]
  }, showTextInputLabel ? /*#__PURE__*/React__default.createElement(AppInputLabel, {
    style: {
      marginBottom: 10,
      marginLeft: 15
    },
    isMandatory: isMandatory,
    label: label
  }) : null, /*#__PURE__*/React__default.createElement(View, {
    style: {
      flexDirection: "row"
    }
  }, items === null || items === void 0 ? void 0 : items.map(i => {
    var _Assets$icons, _Assets$icons2, _currentTheme$theme, _currentTheme$theme2;
    const isSelected = selectedOption == i[propertyValue];
    const isItemDisabled = (i === null || i === void 0 ? void 0 : i.disabled) || false;
    if (i) return /*#__PURE__*/React__default.createElement(AppText, {
      wrapperStyle: {
        paddingHorizontal: 20
      },
      key: i[propertyValue] || i.toString(),
      onLeftIconPress: enabled && (() => {
        if (!isItemDisabled) onSelectionChange(i[propertyValue] !== null ? i[propertyValue] : i.toString());else {
          onSelectionDisabledPress && onSelectionDisabledPress(i);
        }
      }),
      leftIconStyle: {
        paddingRight: 10
      },
      leftIcon: isSelected ? AppAssets === null || AppAssets === void 0 ? void 0 : (_Assets$icons = AppAssets.icons) === null || _Assets$icons === void 0 ? void 0 : _Assets$icons.check : AppAssets === null || AppAssets === void 0 ? void 0 : (_Assets$icons2 = AppAssets.icons) === null || _Assets$icons2 === void 0 ? void 0 : _Assets$icons2.uncheck,
      leftIconColor: isSelected && enabled && !isItemDisabled ? currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme = currentTheme.theme) === null || _currentTheme$theme === void 0 ? void 0 : _currentTheme$theme.primary : currentTheme === null || currentTheme === void 0 ? void 0 : (_currentTheme$theme2 = currentTheme.theme) === null || _currentTheme$theme2 === void 0 ? void 0 : _currentTheme$theme2.grey
    }, i[propertyLabel] || i.toString());
  })), showCaption && _selectedOption && /*#__PURE__*/React__default.createElement(AppText, {
    style: captionStyle,
    wrapperStyle: captionWrapperStyle
  }, _selectedOption[captionLabel]));
};
const styleGenerator = (props, enabled) => {
  var _props$theme, _props$theme2, _props$theme3, _props$theme4, _props$theme5, _props$theme6;
  return StyleSheet.create({
    baseStyle: {
      fontFamily: "normalFont",
      fontSize: props === null || props === void 0 ? void 0 : (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.small_font_size,
      backgroundColor: props === null || props === void 0 ? void 0 : (_props$theme2 = props.theme) === null || _props$theme2 === void 0 ? void 0 : _props$theme2.backgroundColor,
      paddingVertical: 5,
      borderRadius: 25,
      borderColor: props === null || props === void 0 ? void 0 : (_props$theme3 = props.theme) === null || _props$theme3 === void 0 ? void 0 : _props$theme3.border_color,
      borderWidth: 1,
      height: props === null || props === void 0 ? void 0 : (_props$theme4 = props.theme) === null || _props$theme4 === void 0 ? void 0 : _props$theme4.fieldHeight,
      paddingHorizontal: 10,
      color: enabled ? props === null || props === void 0 ? void 0 : (_props$theme5 = props.theme) === null || _props$theme5 === void 0 ? void 0 : _props$theme5.font_color : props === null || props === void 0 ? void 0 : (_props$theme6 = props.theme) === null || _props$theme6 === void 0 ? void 0 : _props$theme6.darkGrey,
      cursor: Platform.OS === "web" && "pointer"
    },
    wrapperContainer: {
      flexDirection: "column",
      backgroundColor: "transparent"
    }
  });
};
AppRadio.__docgenInfo = {
  "description": "",
  "methods": [],
  "displayName": "AppRadio",
  "props": {
    "enabled": {
      "defaultValue": {
        "value": "true",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true, the radio button is enabled"
    },
    "onSelectionChange": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(value: any) => void",
        "signature": {
          "arguments": [{
            "name": "value",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "onSelectionDisabledPress": {
      "defaultValue": {
        "value": "() => {}",
        "computed": false
      },
      "required": false,
      "tsType": {
        "name": "signature",
        "type": "function",
        "raw": "(value: any) => void",
        "signature": {
          "arguments": [{
            "name": "value",
            "type": {
              "name": "any"
            }
          }],
          "return": {
            "name": "void"
          }
        }
      },
      "description": ""
    },
    "items": {
      "required": true,
      "tsType": {
        "name": "Array",
        "elements": [{
          "name": "any"
        }],
        "raw": "any[]"
      },
      "description": "Sets the items to display in the dropdown"
    },
    "showTextInputLabel": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true displays a label at the top of the component"
    },
    "isMandatory": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": "When true it appends an asterix to indicate that it a mandatory field"
    },
    "label": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Text displayed when showTextInputLabel is marked as true"
    },
    "wrapperContainer": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": "Style applied to the overall wrapper of the component"
    },
    "captionStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "captionWrapperStyle": {
      "required": false,
      "tsType": {
        "name": "StyleProp",
        "elements": [{
          "name": "ViewStyle"
        }],
        "raw": "StyleProp<ViewStyle>"
      },
      "description": ""
    },
    "propertyLabel": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Sets the property used for displaying the values"
    },
    "caption": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    },
    "propertyValue": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": "Sets the property used for the value of the selection"
    },
    "selectedOption": {
      "required": false,
      "tsType": {
        "name": "any"
      },
      "description": ""
    },
    "showCaption": {
      "required": false,
      "tsType": {
        "name": "boolean"
      },
      "description": ""
    },
    "captionLabel": {
      "required": false,
      "tsType": {
        "name": "string"
      },
      "description": ""
    }
  }
};

export { AppRadio as A };
